module.exports = __webpack_public_path__ + "img/pizzaGraphic.25a2a56a.png";